module.exports.baseurl = "https://faccc.accmen.net"; // wizmen office local server (Haider)
// module.exports.baseurl = "http://localhost:3008"; //wizmen office local server (Haider)
// module.exports.baseurl = "http://192.168.10.107:3008"; //wizmen office local server (Muhammad Saif Ullah)
